import _ from 'lodash';

// General tabs
import NewGeneralTab from '@modules/generalTab/GeneralTab';
import AttachmentTab from './Items/AttachmentTab';
import HierarchyTab from './Items/HierarchyTab';

// Flavors tabs
import AssetTab from './Assets/forms/AssetTab';
import AssetMainType from './Assets/forms/FormMainType';
import InventoryTab from './Assets/forms/InventoryTab';

import DeviceForm from './Devices/DeviceForm';

import LivestockForm from './Livestock/LivestockForm';
import LivestockType from './Livestock/LivestockType';

import LocationHistoryTab from './Items/LocationHistoryTab';
import LocationRulesTab from './Locations/LocationRulesTab';

//import Person from './People/FormPerson';
import PersonContactData from './People/PersonContactData';

import ItemInCustody from './ItemInCustody/ItemInCustodyForm';

import WipPart from './WipParts/WipPartInfo';

// General type tabs
import GeneralType from './ItemTypes/GeneralTab';

// Item types tabs
import TrackingTab from './ItemTypes/TrackingTab';
import TemplateRules from './ItemTypes/TemplateRulesTab';

import ItemTypeAdvancedConfig from './ItemTypes/ItemTypeHierarchyTab';

import { isAttrNotNull } from './flavor.utils';
import AuditTab from './Locations/AuditTab';
import ProcessTypeTab from './Processes/ProcessTypeTab';
import { CElement, CProcess, IForm } from '@ts/ui-models';
import ProcessGeneralTab from './Processes/generalTab/ProcessGeneralTab';
import DocumentTab from '../Documents/DocumentTab';
import FormProcess from './Processes/ProcessForm';

/* Map from flavor ITEMTYPE to tab ids */
export const flavorNameItemTypeTabIdsMap = {
  element: ['generalType', 'generalTracking', 'templateRules', 'generalCandidateHierarchy'], //generalSettingsType no used
  asset: ['assetMainType', 'assetInventory'],
  livestock: ['livestockType'],
  location: ['locationRules'],
  device: ['device'],
  person: ['person'],
  process: ['processType'],
  vehicle: ['vehicle'],
  wipPart: ['wipPart'],
  itemInCustody: ['itemInCustody'],
};

/* Map from flavor ITEM to tab ids */
export const flavorNameItemTabIdsMap = {
  element: ['general'],
  otherElement: ['generalImages', 'generalAttachments', 'generalHierarchy'],
  asset: ['assetMain', 'assetInventory'],
  device: ['device'],
  livestock: ['livestock'],
  location: ['locationRules', 'audit'],
  person: ['personContactData'],
  process: ['process'],
  vehicle: [],
  wipPart: ['wipPart'],
  itemInCustody: ['itemInCustody'],
};

interface ITabs {
  id: string;
  label: string;
  flavor: string;
  icon: string;
  content: any;
  order: number; // unused
  tabDataPath?: string;
  isMain?: boolean; //Knows if is a principale flavor
  isAux?: boolean; //in mode new, remove auxiliary tabs
  fnDefaultValue?: () => any;
  fnDisabled?: (context: any) => any;
  fnValidate?: (context: any) => (attrs: any) => any;
  fnAfterSave?: (context: any) => (attrs: any) => any;
  fnPrepareSave?: (context: any) => (attrs: any) => any;
}

type TAppTaps = Record<string, ITabs>;

interface IContentTabProps extends IForm {
  values: CElement;
  onChangeValue: (key: string) => (value: any) => void;
  app: any;
  data: any;
  transferPropsRoute: any;
}

export const APP_TABS: TAppTaps = {
  general: {
    id: 'general',
    label: 'General',
    flavor: 'element',
    icon: 'Folder',
    content: (props: IContentTabProps) => {
      switch (props.values.mainFlavor) {
        //case 'process':
        //  return <ProcessGeneralTab {...props} values={new CProcess(props.values)} />;
        default:
          return <NewGeneralTab {...props} />;
      }
    },
    order: 1,
    fnValidate: (context: any) => attrs => {
      console.log('15', 15);
      const errors: any[] = [];
      if (!isAttrNotNull(attrs, 'logicalId')) {
        errors.push(context.props.t('Item logicalId'));
      }
      return errors.length !== 0 ? `${context.props.t('Required field missing')}: ${errors.join(', ')}` : errors;
    },
    fnDefaultValue: () => ({ currentStatus: { indicators: [] } }),
  },

  /*   generalFlavors: {
    id: 'generalFavors',
    label: 'Settings',
    flavor: 'element',
    icon: 'action-settings',
    content: FlavorsTab,
    order: 2,
  }, */

  generalType: {
    id: 'generalType',
    label: 'General',
    flavor: 'element',
    icon: 'Folder',
    content: GeneralType,
    order: 10,
    fnDefaultValue: () => ({
      currentStatus: { indicators: [] },
      templateStatus: { indicators: [] },
    }),
    fnValidate: (context: any) => attrs => {
      const errors: any[] = [];
      if (!isAttrNotNull(attrs, 'logicalId')) {
        errors.push(context.props.t('LogicalId'));
      }
      if (!isAttrNotNull(attrs, 'name')) {
        errors.push(context.props.t('Name'));
      }
      return errors.length !== 0 ? `${context.props.t('Required fields')}: ${errors.join(', ')}` : errors;
    },
    fnAfterSave: (context: any) => attrs => {
      if (attrs.isDefault === true) {
        console.log('itemType afterSave');
      }
      return attrs;
    },
  },

  generalImages: {
    id: 'generalImages',
    label: 'Documents',
    flavor: 'element',
    icon: 'PhotoLibrary',
    content: DocumentTab,
    order: 999,
    fnPrepareSave: (context: any) => attrs => {
      if (attrs.images) {
        attrs.images = attrs.images.map(img => {
          delete img.locator;
          delete img.purpose;
          return img;
        });
      }
      return attrs;
    },
    fnDisabled: (context: any) => {
      const { path } = context.transferPropsRoute || {};
      if (/new$/.test(path)) {
        return true;
      }

      return false;
    },
  },

  generalAttachments: {
    id: 'generalAttachments',
    label: 'Attachments',
    flavor: 'element',
    icon: 'link',
    content: AttachmentTab,
    order: 13,
    isAux: true,
    fnDisabled: (context: any) => {
      const { path } = context.transferPropsRoute || {};
      return /new$/.test(path);
    },
  },

  /*   generalSettingsType: {
    id: 'generalSettingsType',
    label: 'Settings',
    flavor: 'element',
    icon: 'action-settings',
    content: SettingsType,
    order: 15,
  },
 */
  generalHierarchy: {
    id: 'generalHierarchy',
    label: 'Hierarchy',
    flavor: 'element',
    icon: 'AccountTree',
    content: HierarchyTab,
    order: 16,
    isAux: true,
    fnDisabled: (context: any) => {
      const { path } = context.transferPropsRoute || {};
      return /new$/.test(path);
    },
  },

  generalTracking: {
    id: 'generalTracking',
    label: 'Tracking',
    flavor: 'element',
    icon: 'my_location',
    content: TrackingTab,
    order: 100000010,
  },

  templateRules: {
    id: 'templateRules',
    label: 'Template rules',
    flavor: 'element',
    icon: 'Gavel',
    content: TemplateRules,
    order: 100000015,
    fnDefaultValue: () => {
      return {
        seriesConfig: {
          uniqueIdConf: { uniqueId: null, seriesId: null },
          serialNumberConf: { serialNumber: null, seriesId: null },
        },
        nameOfNewItem: 'pn+name',
      };
    },
  },

  generalCandidateHierarchy: {
    id: 'generalCandidateHierarchy',
    label: 'Hierarchy',
    flavor: 'element',
    icon: 'communication-call-merge',
    order: 100000015,
    content: ItemTypeAdvancedConfig,
    fnDisabled: (context: any) => {
      const { path } = context.transferPropsRoute || {};
      return /new$/.test(path);
    },
  },

  assetMain: {
    id: 'assetMain',
    label: 'Asset',
    flavor: 'asset',
    icon: 'action-dashboard',
    tabDataPath: 'flavors.asset',
    content: AssetTab,
    isMain: true,
    fnValidate: (context: any) => attrs => {
      const errors: any[] = [];
      if (!isAttrNotNull(attrs, 'name')) {
        errors.push(context.props.t('Name'));
      }
      return errors.length !== 0 ? `${context.props.t('Required field missing')}: ${errors}` : errors;
    },
    order: 20,
    fnDefaultValue: () => ({ isAlive: true }),
  },

  assetMainType: {
    id: 'assetMainType',
    label: 'Asset',
    flavor: 'asset',
    icon: 'action-dashboard',
    tabDataPath: 'flavors.asset',
    content: AssetMainType,
    order: 40,
    fnDefaultValue: () => ({ isAlive: true }),
  },

  assetInventory: {
    id: 'assetInventory',
    label: 'Inventory',
    flavor: 'asset',
    icon: 'Assignment',
    tabDataPath: 'flavors.asset',
    content: InventoryTab,
    order: 21,
  },

  device: {
    id: 'device',
    label: 'Device',
    flavor: 'device',
    icon: 'hardware-developer-board',
    tabDataPath: 'flavors.device',
    content: DeviceForm,
    isMain: true,
    fnValidate: (context: any) => attrs => {
      const errors: any[] = [];
      if (!isAttrNotNull(attrs, 'deviceTypeId')) {
        errors.push(context.props.t('Device Type'));
      }
      if (!isAttrNotNull(attrs, 'name')) {
        errors.push(context.props.t('Name'));
      }
      if (!isAttrNotNull(attrs, 'logicalId')) {
        errors.push(context.props.t('ID'));
      }
      return errors.length !== 0 ? `${context.props.t('Required fields missing')}: ${errors.join(', ')}` : errors;
    },
    fnPrepareSave: (context: any) => attrs => {
      attrs.sensors &&
        attrs.sensors.map(sensor => {
          sensor.readingType = sensor.readingType.logicalId;
          sensor.operation = sensor.selectedOperation.logicalId;
          delete sensor.selectedOperation;
          delete sensor.availableOperations;
        });
      delete attrs.deviceType;
      return attrs;
    },
    fnDefaultValue: () => {
      return {
        isAlive: true,
        deviceInterfaces: [],
      };
    },
    order: 30,
  },

  livestock: {
    id: 'livestock',
    label: 'Livestock',
    flavor: 'livestock',
    icon: 'action-pets',
    tabDataPath: 'flavors.livestock',
    content: LivestockForm,
    order: 50,
    isMain: true,
    fnValidate: (context: any) => attrs => {
      const errors: any[] = [];
      if (!isAttrNotNull(attrs, 'name')) {
        errors.push(context.props.t('Name'));
      }
      return errors.length !== 0 ? `${context.props.t('Required field missing')}: ${errors.join(', ')}` : errors;
    },
    fnDefaultValue: () => ({ isAlive: true }),
  },

  livestockType: {
    id: 'livestockType',
    label: 'Livestock',
    flavor: 'livestock',
    icon: 'action-pets',
    tabDataPath: 'flavors.livestock',
    content: LivestockType,
    order: 100,
    fnDefaultValue: () => ({ isAlive: true }),
  },

  locationHistory: {
    id: 'locationHistory',
    label: 'Location History',
    flavor: 'element',
    icon: 'locationOn',
    content: LocationHistoryTab,
    order: 2,
    isAux: true,
    fnValidate: (context: any) => attrs => {},
    fnDefaultValue: () => ({}),
    fnDisabled: (context: any) => {
      const { path } = context.transferPropsRoute || {};
      if (/new$/.test(path)) {
        return true;
      }

      return false;
    },
  },

  locationRules: {
    id: 'locationType',
    label: 'Location Rules',
    flavor: 'location',
    icon: 'OfficeBuilding',
    tabDataPath: 'flavors.location',
    content: LocationRulesTab,
    order: 16,
    fnDefaultValue: () => ({ isAlive: true }),
  },
  audit: {
    id: 'audit',
    label: 'Audits',
    flavor: 'location',
    icon: 'rule',
    tabDataPath: 'flavors.location',
    content: AuditTab,
    order: 17,
    isAux: true,
    fnDefaultValue: () => ({ isAlive: true }),
  },

  person: {
    id: 'person',
    label: 'Person',
    flavor: 'person',
    icon: 'Account',
    content: null,
    order: 60,
    isMain: true,
  },

  personContactData: {
    id: 'personContactData',
    label: 'Contact Data',
    flavor: 'person',
    icon: 'ContactPhone',
    tabDataPath: 'flavors.person',
    content: PersonContactData,
    order: 61,
    isAux: true,
    fnDisabled: (context: any) => {
      const { path } = context.transferPropsRoute || {};
      return /new$/.test(path);
    },
  },

  process: {
    id: 'process',
    label: 'Process',
    flavor: 'process',
    icon: 'Timeline',
    tabDataPath: 'flavors.process',
    content: FormProcess,
    order: 70,
    isMain: true,
    fnDefaultValue: () => ({ isAlive: true }),
  },

  processType: {
    id: 'processType',
    label: 'Process',
    flavor: 'process',
    icon: 'Timeline',
    tabDataPath: 'flavors.process',
    content: ProcessTypeTab,
    order: 900,
    fnDefaultValue: () => ({ isAlive: true }),
  },

  vehicle: {
    id: 'vehicle',
    label: 'Vehicle',
    flavor: 'vehicle',
    icon: 'maps-directions-car',
    tabDataPath: 'flavors.vehicle',
    content: null,
    order: 80,
    isMain: true,
    fnDefaultValue: () => ({ isAlive: true }),
  },

  wipPart: {
    id: 'wipPart',
    label: 'Wip Part',
    flavor: 'wipPart',
    icon: 'action-build',
    tabDataPath: 'flavors.wipPart',
    content: WipPart,
    order: 90,
    isMain: true,
    fnDefaultValue: () => ({ isAlive: true }),
  },

  itemInCustody: {
    id: 'itemInCustody',
    label: 'Item in custody',
    flavor: 'itemInCustody',
    icon: 'class',
    tabDataPath: 'flavors.itemInCustody',
    content: ItemInCustody,
    order: 100,
    isMain: true,
    fnDefaultValue: () => ({ isAlive: true }),
  },
};
